(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["antes-despues-barefoot"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pba-compare')) {
    class PbaCompare extends HTMLElement {
      connectedCallback() {
        this.frame = this.querySelector('[data-frame]');
        this.range = this.querySelector('.pba__range');
        if (!this.frame || !this.range) return;

        this.dragging = false;
        this.set(Number(this.range.value));

        this.onDown = (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          this.dragging = true;
          this.classList.add('is-dragging');
          this.frame.setPointerCapture?.(e.pointerId);
          this.fromEvent(e);
        };
        this.onMove = (e) => {
          if (this.dragging) this.fromEvent(e);
        };
        this.onUp = () => {
          this.dragging = false;
          this.classList.remove('is-dragging');
        };

        this.frame.addEventListener('pointerdown', this.onDown);
        this.frame.addEventListener('pointermove', this.onMove);
        this.frame.addEventListener('pointerup', this.onUp);
        this.frame.addEventListener('pointercancel', this.onUp);
        this.range.addEventListener('input', () => this.set(Number(this.range.value)));

        if (this.dataset.hint === 'true') this.setupHint();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      fromEvent(e) {
        const rect = this.frame.getBoundingClientRect();
        if (!rect.width) return;
        this.set(((e.clientX - rect.left) / rect.width) * 100);
      }

      set(value) {
        const v = Math.min(100, Math.max(0, value));
        this.style.setProperty('--pos', v + '%');
        this.range.value = Math.round(v);
        this.range.setAttribute('aria-valuetext', Math.round(v) + '%');
      }

      // Pequeño vaivén la primera vez que se ve, para indicar que se puede arrastrar
      setupHint() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (!('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          if (this.dragging) return;

          const start = Number(this.range.value);
          const steps = [start - 14, start + 14, start];
          this.classList.add('is-hinting');
          steps.forEach((value, i) => {
            setTimeout(() => {
              if (!this.dragging) this.set(value);
              if (i === steps.length - 1) setTimeout(() => this.classList.remove('is-hinting'), 500);
            }, 400 + i * 550);
          });
        }, { threshold: 0.5 });

        this.observer.observe(this.frame);
      }
    }

    customElements.define('pba-compare', PbaCompare);
  }

  // Tarjetas laterales: desplegables solo en móvil/tablet (en ordenador siempre abiertas)
  if (!window.__pbaCards) {
    window.__pbaCards = true;
    const desktop = window.matchMedia('(min-width: 990px)');

    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-pba-toggle]');
      if (!toggle || desktop.matches) return;

      const card = toggle.closest('[data-pba-card]');
      if (!card || card.classList.contains('pba__card--empty')) return;

      const open = !card.classList.contains('is-open');
      card.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cacles-claims"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cacles-claims')) {
    class CaclesClaims extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-ccl-track]');
        if (!this.track) return;

        this.items = Array.from(this.track.children);
        this.dots = Array.from(this.querySelectorAll('[data-ccl-dot]'));
        this.index = 0;
        this.paused = false;
        this.inView = false;
        this.speed = Number(this.dataset.autoplay) || 0;
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // Dots: go to a claim
        this.dots.forEach((dot, i) => {
          dot.addEventListener('click', () => {
            this.pauseForAWhile();
            this.go(i);
          });
        });

        // Which claim is visible (updates the dots)
        this.slideObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.setActive(this.items.indexOf(entry.target));
            });
          },
          { root: this.track, threshold: 0.6 }
        );
        this.items.forEach((item) => this.slideObserver.observe(item));

        // Autoplay only while the section is on screen
        this.viewObserver = new IntersectionObserver((entries) => {
          this.inView = entries[0]?.isIntersecting ?? false;
        });
        this.viewObserver.observe(this);

        // Pause when the customer touches or swipes
        this.onInteract = () => this.pauseForAWhile();
        this.track.addEventListener('pointerdown', this.onInteract, { passive: true });
        this.track.addEventListener('touchstart', this.onInteract, { passive: true });

        this.startAutoplay();
      }

      disconnectedCallback() {
        this.slideObserver?.disconnect();
        this.viewObserver?.disconnect();
        clearInterval(this.timer);
        clearTimeout(this.resumeTimer);
      }

      startAutoplay() {
        if (!this.speed || this.reduceMotion || this.items.length < 2) return;

        clearInterval(this.timer);
        this.timer = setInterval(() => {
          if (!this.mobile.matches || !this.inView || document.hidden || this.paused) return;
          this.go((this.index + 1) % this.items.length);
        }, this.speed * 1000);
      }

      pauseForAWhile() {
        this.paused = true;
        clearTimeout(this.resumeTimer);
        this.resumeTimer = setTimeout(() => {
          this.paused = false;
        }, 6000);
      }

      go(i) {
        const item = this.items[i];
        if (!item) return;
        this.track.scrollTo({ left: item.offsetLeft - this.items[0].offsetLeft, behavior: 'smooth' });
        this.setActive(i);
      }

      setActive(index) {
        if (index < 0) return;
        this.index = index;
        this.dots.forEach((dot, i) => {
          if (i === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    }

    customElements.define('cacles-claims', CaclesClaims);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cifras-barefoot"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pbs-stats')) {
    class PbsStats extends HTMLElement {
      connectedCallback() {
        if (this.dataset.animate !== 'true') return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (!('IntersectionObserver' in window)) return;

        this.duration = Number(this.dataset.duration) || 1800;
        this.stagger = this.dataset.stagger === 'true' ? 180 : 0;
        this.items = [...this.querySelectorAll('[data-count]')]
          .map((el) => ({ el, ...this.parse(el.dataset.count) }))
          .filter((item) => item.valid);

        if (!this.items.length) return;

        // Reservar el ancho final para que el texto no "baile" durante la animación
        this.items.forEach((item) => {
          item.el.style.minWidth = item.el.getBoundingClientRect().width + 'px';
          item.el.textContent = this.format(0, item.decimals);
        });

        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.run();
        }, { threshold: 0.35 });

        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }

      // Admite "57", "4,7", "40.000", "1.250,5"
      parse(raw) {
        const original = String(raw || '').trim();
        let normalized = original;
        let decimals = 0;

        if (original.includes(',')) {
          const [int, frac = ''] = original.split(',');
          normalized = int.replace(/\./g, '') + '.' + frac.replace(/\D/g, '');
          decimals = frac.replace(/\D/g, '').length;
        } else if (/^\d{1,3}(\.\d{3})+$/.test(original)) {
          normalized = original.replace(/\./g, '');
        } else {
          const match = original.match(/\.(\d+)/);
          decimals = match ? match[1].length : 0;
        }

        const target = parseFloat(normalized.replace(/[^\d.-]/g, ''));
        return { target, decimals, original, valid: !Number.isNaN(target) };
      }

      format(value, decimals) {
        return new Intl.NumberFormat('es-ES', {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals
        }).format(value);
      }

      run() {
        const start = performance.now();
        const ease = (t) => 1 - Math.pow(1 - t, 3);

        const tick = (now) => {
          let done = true;

          this.items.forEach((item, i) => {
            const elapsed = now - start - i * this.stagger;
            const t = Math.min(1, Math.max(0, elapsed / this.duration));
            if (t < 1) done = false;
            item.el.textContent = t >= 1 ? item.original : this.format(item.target * ease(t), item.decimals);
          });

          if (!done) {
            this.frame = requestAnimationFrame(tick);
          } else {
            this.items.forEach((item) => {
              item.el.textContent = item.original;
              item.el.style.minWidth = '';
            });
          }
        };

        this.frame = requestAnimationFrame(tick);
      }
    }

    customElements.define('pbs-stats', PbsStats);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('click', (event) => {
    const sizeLink = event.target.closest('.collection-card-sizes__link');

    if (sizeLink) {
      event.stopPropagation();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-claims')) {
    class ProductClaims extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        if (!this.track || this.slides.length < 2) return;

        this.index = 0;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.sync());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        this.dots.forEach((dot, i) => {
          dot.addEventListener('click', () => {
            this.go(i);
            this.start();
          });
        });

        this.delay = (Number(this.dataset.autoplay) || 0) * 1000;
        if (this.delay && !this.reduced) {
          ['pointerenter', 'focusin', 'touchstart'].forEach((ev) =>
            this.addEventListener(ev, () => this.stop(), { passive: true })
          );
          ['pointerleave', 'focusout', 'touchend'].forEach((ev) =>
            this.addEventListener(ev, () => this.start(), { passive: true })
          );
          this.start();
        }
      }

      disconnectedCallback() {
        this.stop();
        this.track?.removeEventListener('scroll', this.onScroll);
      }

      isCarousel() {
        return getComputedStyle(this.track).display === 'flex';
      }

      setActive(i) {
        this.index = i;
        this.dots.forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
      }

      sync() {
        const w = this.track.clientWidth;
        if (!w) return;
        const i = Math.round(this.track.scrollLeft / w);
        if (i !== this.index) this.setActive(i);
      }

      go(i) {
        const n = this.slides.length;
        const next = ((i % n) + n) % n;
        this.setActive(next);
        this.track.scrollTo({
          left: next * this.track.clientWidth,
          behavior: this.reduced ? 'auto' : 'smooth'
        });
      }

      start() {
        this.stop();
        if (!this.delay) return;
        this.timer = setInterval(() => {
          if (this.isCarousel() && !document.hidden) this.go(this.index + 1);
        }, this.delay);
      }

      stop() {
        clearInterval(this.timer);
      }
    }

    customElements.define('product-claims', ProductClaims);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-highlights"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-highlights')) {
    class ProductHighlights extends HTMLElement {
      connectedCallback() {
        this.cards = [...this.querySelectorAll('[data-card]')];

        this.cards.forEach((card) => {
          const front = card.querySelector('[data-front]');
          const back = card.querySelector('[data-back]');
          const close = card.querySelector('[data-close]');
          if (!front || !back) return;

          back.inert = true;
          front.addEventListener('click', () => this.flip(card, true));
          close?.addEventListener('click', () => this.flip(card, false));
          card.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && card.classList.contains('is-flipped')) this.flip(card, false);
          });
        });
      }

      flip(card, open) {
        const front = card.querySelector('[data-front]');
        const back = card.querySelector('[data-back]');
        const close = card.querySelector('[data-close]');

        card.classList.toggle('is-flipped', open);
        front.setAttribute('aria-expanded', open ? 'true' : 'false');
        front.inert = open;
        back.inert = !open;

        if (open) {
          close?.focus({ preventScroll: true });
        } else {
          front.focus({ preventScroll: true });
        }
      }
    }

    customElements.define('product-highlights', ProductHighlights);
  }

  } catch(e) { console.error(e); }
})();
})();
